<template>
  <card-total
    text="NAVISION vs NAVIXY"
    icon="mdi mdi-file-document-edit  danger-text"
    :total="total"
    :loading.sync="loading"
  >
    <template #total="slotProsps">
      <a href="#" @click.prevent="openDetail">{{ slotProsps.total }}</a>
    </template>
    <template #moreIcons>
      <span style="font-size: 95%" class="info-text self-flex-start">
        <i class="el-icon-view" /> Equipos : {{ qtyEquipment }}</span
      >
      <NavisionNavixyDiffMaster :drawer.sync="drawer" :items="items" />
    </template>
  </card-total>
</template>

<script>
import CardTotal from "@/components/CardTotalOriginal.vue";
import NavisionNavixyDiffMaster from "@/components/NavisionAndNavixy.vue";

export default {
  name: "CardStatDiffEquipmentNavisionVsNavixy",
  components: { CardTotal, NavisionNavixyDiffMaster },
  created() {
    this.getReport();
  },
  data() {
    return {
      total: 0,
      loading: false,
      drawer: false,
      qtyEquipment: 0,
      items: []
    };
  },
  methods: {
    openDetail() {
      this.drawer = true;
    },
    getReport() {
      this.loading = true;
      this.$http
        .get("/api/navixy/GetReportNavixyVsNavision", {
          timeout: 3 * 60 * 1000
        })
        .then((resp) => {
          const { stat, details } = resp.data;
          this.total = stat.TotalLines;
          this.qtyEquipment = stat.DIFF;
          this.items = details;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
